// Small, pure helpers the sign-in pages share. Kept free of React and of
// process.env so they work the same in tests and in the browser.

// The query for a relative in-app path, built by URLSearchParams, so an
// email with "+" or a base64 redirect survives the round trip. Empty values
// are left out. '' when nothing is left, else '?...'.
export const authSearch = (params = {}) => {
  const query = new URLSearchParams()

  Object.entries(params).forEach(([key, value]) => {
    if (value) {
      query.set(key, value)
    }
  })

  const search = query.toString()

  return search ? `?${search}` : ''
}

// A relative in-app path with its query (authSearch).
export const authPath = (path, params = {}) => `${path}${authSearch(params)}`

// The domain of an email, lower-cased, or '' when the value isn't
// something@domain (a username, "@acme.com", "someone@").
export const domainOf = value => {
  const v = (value || '').trim()
  const at = v.lastIndexOf('@')

  return at > 0 && at < v.length - 1 ? v.slice(at + 1).toLowerCase() : ''
}

// The value GET /provider-link/:id is asked about: the FULL email, so a
// connection limited to named testers (its test allowlist) can match
// (audit B2). Encoded, because it travels as one path segment.
export const providerLinkKey = email => encodeURIComponent((email || '').trim())

// The query every sign-in page carries forward: where to go after signing
// in (redirect, redirect-doc), and the email being signed in.
export const carryParams = ({ redirect, redirectDoc, email }) => ({
  email,
  redirect,
  'redirect-doc': redirectDoc
})
